import { Typography } from '@mui/material';
import i18next from 'i18next';
import React from 'react';
import { useRouteError } from 'react-router-dom';
import { FullWidthBox } from '../../components/fullWidthBox/FullWidthBox';

interface ErrorFallbackProps {
  error?: Error;
}

export const ErrorFallback: React.FC<ErrorFallbackProps> = ({ error }) => {
  const routeError = useRouteError() as { message: string };

  return (
    <FullWidthBox>
      <Typography variant="h1">{i18next.t('somethingWentWrong')}</Typography>
      <Typography variant="h2" color="red">
        {error ? error.message : routeError.message}
      </Typography>
    </FullWidthBox>
  );
};
